/* UKL — Direction artistique : mot « pinceau » + animations (08/10).
   1. Met le DERNIER MOT des titres (sections, collections, fiche produit,
      tuiles de collections) dans la police pinceau façon logo « URBAN ».
      Exception : « URBAN KICKLAB » -> c'est « URBAN » qui passe en pinceau, comme le logo.
   2. Fait apparaître en douceur les sections au défilement.
   Ne touche ni aux bannières du haut, ni au header, ni au panier. */
(function () {
  var TARGETS = [
    'main h2[class*="__title"]',
    'main h2[class*="__heading"]',
    'main .collection-header__title',
    '.sf-prod__info-wrapper .prod__title h1',
    '.nk-cats__name',
    '.nk-sc__name',
    '.nk-cc__title'
  ].join(',');
  var SKIP = '.nk-hero, .nk-ticker, .sf-header, .m-cart-drawer, [data-ukl-skip]';
  var L = 'A-Za-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF0-9';
  var LAST = new RegExp('^([\\s\\S]*?)([' + L + '][' + L + "'\\u2019-]*)([^" + L + ']*)$');
  var URBAN = /^(\s*)(URBAN)(\s+KICKLAB[\s\S]*)$/i;

  function make(parts) {
    var frag = document.createDocumentFragment();
    if (parts[0]) frag.appendChild(document.createTextNode(parts[0]));
    var span = document.createElement('span');
    span.className = 'ukl-brush';
    span.textContent = parts[1];
    frag.appendChild(span);
    if (parts[2]) frag.appendChild(document.createTextNode(parts[2]));
    return frag;
  }

  function brush(el) {
    if (el.getAttribute('data-ukl-brush') || el.closest(SKIP)) return;
    if (el.querySelector('.ukl-brush')) { el.setAttribute('data-ukl-brush', '1'); return; }
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    var full = el.textContent || '';
    if (nodes.length === 1 && URBAN.test(full)) {
      var u = nodes[0].nodeValue.match(URBAN);
      if (u) { nodes[0].parentNode.replaceChild(make([u[1], u[2], u[3]]), nodes[0]); el.setAttribute('data-ukl-brush', '1'); return; }
    }
    for (var i = nodes.length - 1; i >= 0; i--) {
      var t = nodes[i];
      if (!t.nodeValue || !t.nodeValue.trim()) continue;
      if (t.parentNode && t.parentNode.closest && t.parentNode.closest('.visually-hidden')) continue;
      var m = t.nodeValue.match(LAST);
      if (!m || !m[2]) continue;
      t.parentNode.replaceChild(make([m[1], m[2], m[3]]), t);
      el.setAttribute('data-ukl-brush', '1');
      return;
    }
  }
  function brushAll() {
    var els = document.querySelectorAll(TARGETS);
    for (var i = 0; i < els.length; i++) brush(els[i]);
  }

  function reveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    var secs = document.querySelectorAll('main > .shopify-section');
    for (var i = 0; i < secs.length; i++) {
      var s = secs[i];
      if (s.querySelector('.nk-hero, .nk-ticker')) continue;
      var r = s.getBoundingClientRect();
      if (r.height === 0 || r.top < window.innerHeight * 0.92) continue; /* déjà visible : pas d'animation */
      s.classList.add('ukl-rv');
      io.observe(s);
    }
    /* Sécurité : tout ce qui est à l'écran est affiché au bout de 6 s */
    setTimeout(function () {
      var left = document.querySelectorAll('.ukl-rv:not(.is-in)');
      for (var j = 0; j < left.length; j++) {
        var rr = left[j].getBoundingClientRect();
        if (rr.top < window.innerHeight) left[j].classList.add('is-in');
      }
    }, 6000);
  }

  function init() {
    brushAll();
    reveal();
    setTimeout(brushAll, 1200);
    setTimeout(brushAll, 3500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
